import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal as EPModal, Copy, Button, Flex, Image } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const CancelBookingModal = ({ isShown, onClose, onCancelBooking, pageName }) => {
    useEffect(() => {
        if (isShown) {
            trackTealiumEvent(RentalCarEvents.showCancelBookingConfirmBookingModal(pageName))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShown])
    return <EPModal isShown={isShown} onClose={onClose} width='812px' height={['100%', 'auto']} label=' ' showModalTitle={false}>
        <Flex mt={['1em', '3em']} flexDirection='column' textAlign='center'>
            <Image src='/images/rental-car/cancel-booking.svg' width='200px' height='200px' alignSelf='center' alt='cancel' />
            <Copy size={['large', 'xxLarge']} fontWeight='medium' color='accent_dark' padding='1em 0em'>
                <FormattedMessage defaultMessage='¿Seguro que quieres cancelar tu reserva?'/>
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='La cancelación de tu reserva es gratuita. Si quieres puedes buscar otras opciones parecidas.'/>
            </Copy>
            <Flex width='100%' alignSelf='end' alignContent='center' justifyContent='center' mt='1em' mb={['0em', '1em']} flexDirection={['column-reverse', 'row']}>
                <Button.bordered dataTest='refuse-cancel-booking-button' onClick={() => {
                    trackTealiumEvent(RentalCarEvents.eventCancelBookingConfirmBookingModalClose(pageName))
                    onClose()
                }} fontWeight='bold' mr={['0em', '1em']} > <FormattedMessage defaultMessage='Mantener reserva'/></Button.bordered>
                <Button dataTest='accept-cancel-booking-button' onClick={() => {
                    trackTealiumEvent(RentalCarEvents.eventCancelBookingConfirmBookingModalCancel(pageName))
                    onCancelBooking()
                }} fontWeight='bold' mb={['1em', '0em']}> <FormattedMessage defaultMessage='Cancelar reserva'/></Button>
            </Flex>
        </Flex>
    </EPModal>
}

CancelBookingModal.propTypes = {
    isShown: PropTypes.bool,
    onCancelBooking: PropTypes.func,
    onClose: PropTypes.func,
    pageName: PropTypes.string,
}
export default CancelBookingModal
